module.exports = __webpack_public_path__ + "static/media/menu-manual-video-icon.a5a62a22.svg";